import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { ESlice } from '@enums/redux.enum';

import authReducer from './auth/authSlice';
import tripsReducer from './trips/tripsSlice';

const rootReducer = combineReducers({
	[ESlice.auth]: authReducer,
	[ESlice.trips]: tripsReducer,
});

const persistConfig = {
	key: ESlice.root,
	storage,
	whitelist: [ESlice.auth],
};

export default persistReducer(persistConfig, rootReducer);
